/* import __COLOCATED_TEMPLATE__ from './footer.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@classNames('card-footer')
export default class SharedCardFooter extends Component {}
